/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DocumentListItemDto } from './DocumentListItemDto';
import {
    DocumentListItemDtoFromJSON,
    DocumentListItemDtoFromJSONTyped,
    DocumentListItemDtoToJSON,
    DocumentListItemDtoToJSONTyped,
} from './DocumentListItemDto';

/**
 * 
 * @export
 * @interface PagedDocumentDto
 */
export interface PagedDocumentDto {
    /**
     * 
     * @type {Array<DocumentListItemDto>}
     * @memberof PagedDocumentDto
     */
    content: Array<DocumentListItemDto>;
    /**
     * 
     * @type {number}
     * @memberof PagedDocumentDto
     */
    number: number;
    /**
     * 
     * @type {number}
     * @memberof PagedDocumentDto
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof PagedDocumentDto
     */
    numberOfElements: number;
    /**
     * 
     * @type {boolean}
     * @memberof PagedDocumentDto
     */
    last: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedDocumentDto
     */
    totalPages: number;
    /**
     * 
     * @type {boolean}
     * @memberof PagedDocumentDto
     */
    first: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedDocumentDto
     */
    totalElements: number;
    /**
     * 
     * @type {boolean}
     * @memberof PagedDocumentDto
     */
    empty: boolean;
}

/**
 * Check if a given object implements the PagedDocumentDto interface.
 */
export function instanceOfPagedDocumentDto(value: object): value is PagedDocumentDto {
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('numberOfElements' in value) || value['numberOfElements'] === undefined) return false;
    if (!('last' in value) || value['last'] === undefined) return false;
    if (!('totalPages' in value) || value['totalPages'] === undefined) return false;
    if (!('first' in value) || value['first'] === undefined) return false;
    if (!('totalElements' in value) || value['totalElements'] === undefined) return false;
    if (!('empty' in value) || value['empty'] === undefined) return false;
    return true;
}

export function PagedDocumentDtoFromJSON(json: any): PagedDocumentDto {
    return PagedDocumentDtoFromJSONTyped(json, false);
}

export function PagedDocumentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagedDocumentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'content': ((json['content'] as Array<any>).map(DocumentListItemDtoFromJSON)),
        'number': json['number'],
        'size': json['size'],
        'numberOfElements': json['numberOfElements'],
        'last': json['last'],
        'totalPages': json['totalPages'],
        'first': json['first'],
        'totalElements': json['totalElements'],
        'empty': json['empty'],
    };
}

export function PagedDocumentDtoToJSON(json: any): PagedDocumentDto {
    return PagedDocumentDtoToJSONTyped(json, false);
}

export function PagedDocumentDtoToJSONTyped(value?: PagedDocumentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': ((value['content'] as Array<any>).map(DocumentListItemDtoToJSON)),
        'number': value['number'],
        'size': value['size'],
        'numberOfElements': value['numberOfElements'],
        'last': value['last'],
        'totalPages': value['totalPages'],
        'first': value['first'],
        'totalElements': value['totalElements'],
        'empty': value['empty'],
    };
}

